import { render, staticRenderFns } from "./DictValueList.vue?vue&type=template&id=6d21a5da&"
import script from "./DictValueList.vue?vue&type=script&lang=js&"
export * from "./DictValueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports